import React from 'react';
import { Link } from 'react-router-dom';

import { SocialMedia } from './reusable/social-media';

export const Footer = () => {
  return (
    <div className="footer container-fullWidth index">
      <div className="row col-12 container">
        <div className="col-4 column"><a target="_blank" href="https://designintime.at">by designintime werbeagentur e.U.</a></div>
        <div className="col-4 column"><SocialMedia /></div>
        <div className="col-4 column">
          <p>
            <Link to="/impressum">Impressum  </Link> |
            <Link to="/datenschutz">   Datenschutz</Link>
          </p>
        </div>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/footer.js